const config = {
    API_URL: 'https://wi6ixbsm1i.execute-api.us-east-2.amazonaws.com/prod'
};

export default config;